// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"860b47e1","3511":"a99626da","3807":"8516e81d","3830":"860e86c2","5046":"f7f59c36","7812":"9b099e0e"}[chunkId] + ".chunk.css";
};